import { Rule } from "antd/es/form";
import { regexpLetter } from "../RegexpConstants";

export const ruleLettersOnly: Rule = {
  pattern: regexpLetter,
  message: "Пожалуйста, введите только буквы",
};

export const ruleSurnameMin: Rule = {
  min: 2,
  message: "Фамилия пользователя не должна быть меньше 2 символов",
};

export const ruleSurnameMax: Rule = {
  max: 25,
  message: "Фамилия пользователя не должна быть больше 25 символов",
};

export const ruleNameMin: Rule = {
  min: 2,
  message: "Имя пользователя не должно быть меньше 2 символов",
};

export const ruleNameMax: Rule = {
  max: 25,
  message: "Имя пользователя не должно быть больше 25 символов",
};

export const rulePatronymicMin: Rule = {
  min: 2,
  message: "Отчество пользователя не должно быть меньше 2 символов",
};

export const rulePatronymicMax: Rule = {
  max: 25,
  message: "Отчество пользователя не должно быть больше 25 символов",
};

export const ruleAddress: Rule = {
  max: 200,
  message: "Адрес не должен быть больше 200 символов",
};
